import React from 'react';
import ReactDOM from 'react-dom';
require("../images/overllImge.png")

class OverallSituationModelDiv extends React.Component {

    constructor(props) {
        super(props);
      }
      render () {
        return(<div style={{width:'100%',height:'100%',backgroundColor: 'rgb(0,0,0,0.7)',display: 'flex',alignItems: 'center',justifyContent: 'center'}}>
          <img src='../images/overllImge.png' style={{width:'40%'}}></img>
        </div>);
      }
}

OverallSituationModelDiv.defaultProps = {
};
export default OverallSituationModelDiv;


// WEBPACK FOOTER //
// ./src/websocket/OverallSituationModelDiv.js